import { Provider, IProvider } from '../../types';

export default abstract class BaseProvider implements IProvider {
  public config: Provider['SSO'];
  public isLoaded?: boolean;
  public account: any;
  public onError?: (error: any) => void;

  constructor(config: Provider['SSO']) {
    this.config = config;
  }
  public abstract loadScript(onLoaded?: any, onError?: any): void;
  public abstract login(): void;
  public abstract logout(): void;
  public abstract acquireToken(): Promise<string>;
  public abstract isAuthenticated(): boolean;
}
